'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _createReducer;

var _lodash = require('lodash');

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setFilter(filtersState, action) {
  var values = Array.isArray(action.values) ? action.values : [action.values];

  if (action.values && !(0, _lodash.isEqual)(filtersState[action.fieldName], values)) {
    return (0, _extends4.default)({}, filtersState, (0, _defineProperty3.default)({}, action.fieldName, values));
  } else if (!action.values && filtersState[action.fieldName]) {
    var field = filtersState[action.fieldName],
        newState = (0, _objectWithoutProperties3.default)(filtersState, [action.fieldName]);


    return newState;
  }

  return filtersState;
}

function clearFilters() {
  return {};
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _actions.SET_FILTER, setFilter), (0, _defineProperty3.default)(_createReducer, _actions.CLEAR_FILTERS, clearFilters), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/reducer.js
// module id = 927
// module chunks = 0